import React, {useEffect, useState} from 'react'
import {Button, Card, Table} from "antd";
import {getAddressByCustomerId} from "../../services/serviceAddress";
import {useParams} from "@reach/router";
import AddressesCreate from "./AddressesCreate";
import AddressesActions from "./AddressesActions";

const Addresses = () => {

    const {customerId} = useParams()
    const [updateList, setListUpdate] = useState(false)
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)

    useEffect(() => {
        getAddressByCustomerId(customerId)
            .then(({data}) => {
                handlers.sortData(data)
            })
    }, [updateList])

    const handlers = {
        updater(){
            setListUpdate(!updateList)
        },
        modalCloser(){
            setNewModal(!newModal)
        },
        sortData(list){
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    customer: item.customer.name,
                    customerObj: item.customer,
                    title: item.title,
                    address: item.address,
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    }

    const columns = [
        {
            title: 'Müşteri',
            dataIndex: 'customer',
            key: 'customer'
        },
        {
            title: 'Başlık',
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address'
        },
        {
            title: 'İşlemler',
            render: (text, record) => <AddressesActions record={record} updater={handlers.updater} />
        }
    ]

    return(
        <React.Fragment>
            <Card
                title={'Adres Listesi'}
                extra={
                    <Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>
                }
            >
                <Table scroll={{x: 'max-content'}} columns={columns}
                       dataSource={sortedList} />
            </Card>

            {newModal ? <AddressesCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} />
                : null
            }
        </React.Fragment>
    )
}
export default Addresses